import {creates, hoistCmp} from '@xh/hoist/core';
import {AllocationsModel} from './AllocationsModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import {addAllocationDialog} from './AddAllocationDialog';
import {toolbar, toolbarSep} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {hbox} from '@xh/hoist/cmp/layout';
import './Allocations.scss';

export const allocations = hoistCmp.factory({
    model: creates(AllocationsModel),
    render({model}) {
        return panel({
            tbar: tbar(),
            items: [grid(), addAllocationDialog({model: model.addAllocationDialog})]
        });
    }
});

const tbar = hoistCmp.factory<AllocationsModel>(({model}) =>
    toolbar(
        button({
            icon: Icon.add(),
            text: 'Add',
            intent: 'primary',
            onClick: () => model.addNew(null)
        }),
        toolbarSep(),
        hbox({
            omit: model.isValid,
            alignItems: 'center',
            items: [Icon.xCircle(), 'Please correct errors before saving'],
            className: 'allocation-error'
        }),
        button({
            icon: Icon.check(),
            text: 'Save Changes',
            intent: 'success',
            disabled: !model.isDirty || !model.isValid,
            onClick: () => model.saveAsync()
        }),
        button({
            icon: Icon.undo(),
            text: 'Revert Changes',
            intent: 'warning',
            disabled: !model.isDirty,
            onClick: () => model.revertAll()
        }),
        button({
            icon: Icon.refresh(),
            text: 'Refresh',
            onClick: () => model.refresh()
        })
    )
);
